import axios from "@/plugins/axios";
import * as admins from "./admins";

export const user = {
    ...admins,
}
